import {AuthUser} from '../models/AuthUser';

export const LOGIN_START = 'LOGIN_START';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const UPDATE_USER = 'UPDATE_USER';
export const LOG_OUT = 'LOG_OUT';
export const SET_USER_EMAIL = 'SET_USER_EMAIL';
export const FETCH_USER_EMAIL = 'FETCH_USER_EMAIL';
export const FETCH_USER_EMAIL_SUCCESS = 'FETCH_USER_EMAIL_SUCCESS';
export const FETCH_USER_EMAIL_ERROR = 'FETCH_USER_EMAIL_ERROR';
export const SYNC_AUTH_STATE = 'SYNC_AUTH_STATE';

export interface UpdateAuthUserActions {
  type: typeof UPDATE_USER;
  payload: AuthUser | null;
}

export interface LoginSuccess {
  type: typeof LOGIN_SUCCESS;
  payload: AuthUser;
}

export interface LoginStart {
  type: typeof LOGIN_START;
}

export interface LoginError {
  type: typeof LOGIN_ERROR;
  payload: string;
}

export interface LogOut {
  type: typeof LOG_OUT;
}

export interface SetUserEmail {
  type: typeof SET_USER_EMAIL;
  payload: string;
}

export interface FetchUserEmail {
  type: typeof FETCH_USER_EMAIL;
}

export interface FetchUserEmailSuccess {
  type: typeof FETCH_USER_EMAIL_SUCCESS;
  payload: string;
}

export interface FetchUserEmailError {
  type: typeof FETCH_USER_EMAIL_ERROR;
}

export interface SyncAuthState {
  type: typeof SYNC_AUTH_STATE;
  payload: any;
}

export type AuthActions =
  | UpdateAuthUserActions
  | LoginStart
  | LoginSuccess
  | LoginError
  | LogOut
  | SetUserEmail
  | FetchUserEmail
  | FetchUserEmailSuccess
  | FetchUserEmailError
  | SyncAuthState;
